import React from 'react'
import { Typography, Box } from '@mui/material'

/**
 * Renders different types of trigger elements based on the provided configuration
 *
 * @param {Object} props - Component props
 * @param {Object} props.trigger - Trigger configuration
 * @param {string} props.trigger.type - Type of trigger: 'text', 'image', 'base64', 'svg'
 * @param {string} props.trigger.value - Content of the trigger
 * @param {Object} props.trigger.style - Style for the trigger
 *
 * The component supports the following trigger types:
 * - text: Renders text content with optional HTML
 * - image: Renders an image from a URL
 * - base64: Renders an image from a base64 encoded string
 * - svg: Renders an SVG element from markup
 */
const TriggerRenderer = ({ trigger }) => {
    if (!trigger) return null

    const { type, value, style = {} } = trigger

    switch (type) {
        case 'text':
            return (
                <Typography
                    component="span"
                    sx={{
                        fontSize: '1.4rem',
                        ...style,
                    }}
                    dangerouslySetInnerHTML={{ __html: value }}
                />
            )

        case 'image':
            return (
                <Box
                    component="img"
                    src={value}
                    alt="Menu item"
                    sx={{
                        width: '2.4rem',
                        height: '2.4rem',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        objectPosition: 'center',

                        ...style,
                    }}
                />
            )

        case 'base64':
            return (
                <Box
                    component="img"
                    src={value}
                    alt="Menu item"
                    sx={{
                        width: '2.4rem',
                        height: '2.4rem',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        ...style,
                    }}
                />
            )

        case 'svg':
            return (
                <Box
                    component="div"
                    sx={{
                        width: '2.4rem',
                        height: '2.4rem',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        objectPosition: 'center',

                        '& > svg': {
                            width: 'inherit',
                            height: 'inherit',
                        },
                        ...style,
                    }}
                    dangerouslySetInnerHTML={{ __html: value }}
                />
            )

        default:
            return null
    }
}

export default TriggerRenderer
